import React, { useEffect } from "react";
import { styled } from "styled-components";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";
import TicketSelection from "./TicketSelection";

const TicketSelectionGrid = ({ products, onSubtract, onAdd, vibration, isLww }) => {
  return (
    <TicketSelectionContainer>
      <ParkLabel>{Text.selectTickets}</ParkLabel>
      {products?.length > 0 &&
        products.filter((item)=>item?.dontShowInCart !== true ).map((item) => (
          <TicketSelection
            vibration={vibration}
            ticket={item}
            onSubtract={onSubtract}
            onAdd={onAdd}
            isLww={isLww}
          />
        ))}
    </TicketSelectionContainer>
  );
};

const ParkLabel = styled.div`
  font-size: 1.25rem;
  font-weight: 600;
`;

const TicketSelectionContainer = styled.div`
  padding: 1rem 0 2rem 0;
  border-bottom: 1px solid ${Colors.chineeseSilver};
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export default TicketSelectionGrid;
